import { eventBus } from "../eventBus.js";
import { onBeforeUnmount, onMounted } from "#imports";
export default function(name, cb) {
  onMounted(() => {
    eventBus.on(name, cb);
  });
  onBeforeUnmount(() => {
    eventBus.off(name, cb);
  });
}
